/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Radio,
  Row,
  Col,
  Form,
  Input,
  Space,
  Button,
  Select,
  message,
  Spin,
  Alert,
  Modal,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import {
  CheckCircleOutlined,
  StopOutlined,
  CloseCircleOutlined,
  //EyeOutlined,
} from "@ant-design/icons";

import { ReactComponent as Scan_check } from "../../assests/images/SVG/check.svg";
import API from "../../api";
import urls from "../../api/urls";
import Heading from "./Heading";
import { checkNumbervalue, checkSpace } from "../../utils";
const {
  SEND_OTP,
  UDPATE_CP_CUSTOMER_KYC,
  GET_KYC__ALL_DETAILS,
  GET_CP_COMPANY_KYC,
  INITIATE_KYC_OTP,
  PROPS_VERIFY_KYC_OTP,
  GET_CP_COMPANY_KYC_SHARED,
  GET_CP_CUSTOMER_KYC,
} = urls;

const KycDetails = ({ handleStepsChange, goBackStep, kycData, companies }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [countdown, setCountdown] = useState(0);
  const [isGstRegister, setIsGstRegister] = useState(true);
  const [panBusinees, setPanBusinees] = useState(false);
  const [otpvisible, setOptVisible] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [showVerifyOtp, setShowVerifyOtp] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [companyId, setCompanyId] = useState(
    JSON.parse(localStorage.getItem("selectedCompany")) || null
  );

  const [otpVerified, setOtpVerified] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const [shareKYC, setShareKYC] = useState(false);

  const typeOfBusinessOptions = [
    {
      value: "Individual",
      label: "Individual",
    },
    {
      value: "Proprietorship",
      label: "Proprietorship",
    },
    {
      value: "Private limited",
      label: "Private limited",
    },
    {
      value: "Public limited",
      label: "Public limited",
    },
    {
      value: "LLP",
      label: "LLP",
    },
    {
      value: "Partnership",
      label: "Partnership",
    },
  ];

  useEffect(() => {
    if (kycData) {
      getKycInfo();
    }
  }, [kycData]);

  const getKycInfo = async () => {
    const GST =
      kycData?.kycDocuments?.find((doc) => doc.idType === "GST")?.idNumber ||
      null;

    const gstRegistred =
      kycData?.kycDocuments?.find((doc) => doc.idType === "GST")
        ?.isRegistered || GST
        ? true
        : false;
    const PAN =
      kycData?.kycDocuments?.find((doc) => doc.idType === "PAN")?.idNumber ||
      null;
    const AADHAR =
      kycData?.kycDocuments?.find((doc) => doc.idType === "AADHAR")?.idNumber ||
      null;

    const TAN =
      kycData?.kycDocuments?.find((doc) => doc.idType === "TAN")?.idNumber ||
      null;

    if (companyId?.isKycCompleted) {
      setShowVerify(false);
    } else {
      setShowVerify(true);
    }
    setIsGstRegister(gstRegistred);
    form.setFieldsValue({
      isGstRegistered: gstRegistred,
      aadharNumber: AADHAR,
      gstNumber: GST,
      businessType: kycData?.businessDetail?.natureOfBusiness,
      tanNumber: TAN,
      signatoryPAN: PAN,
    });

    //setLoading(true);
    // let response = await API.Api(GET_KYC__ALL_DETAILS).getWithPremiseHeader();
    // let data = response?.response?.data;
    // if (response?.status) {
    //   setLoading(false);
    //   setIsGstRegister(data?.isGstRegistered);
    //   form.setFieldsValue({
    //     isGstRegistered: data?.isGstRegistered,
    //     aadharNumber: data?.aadharNumber,
    //     gstNumber: data?.gstNumber,
    //     businessType: data?.businessType,
    //     tanNumber: data?.tanNumber,
    //     signatoryPAN: data?.signatoryPAN,
    //   });
    //   setShowSave(false);
    // } else {
    //   setLoading(false);
    // }
  };

  const radioChange = (e) => {
    form.setFieldsValue({
      isGstRegister: e.target.value,
      aadharNumber: null,
      gstNumber: null,
      otp: null,
    });
    setIsGstRegister(e.target.value);
    setShowVerify(false);
  };

  const onFinish = async (val) => {
    setLoading(true);

    let payload = {
      customer: {
        businessDetail: {
          natureOfBusiness: val?.businessType,
          isGstRegistered: val?.isGstRegistered,
          // gstNumber: val?.gstNumber,
          // aadharNumber: val?.aadharNumber,
          // tanNumber: val?.tanNumber,
          // signatoryPAN: val?.signatoryPAN,
        },
        kycDocuments: [
          {
            idType: "GST",
            idNumber: val?.gstNumber,
            // isVerified: val?.isGstRegistered,
            isRegistered: isGstRegister,
          },
          {
            idType: "PAN",
            idNumber: val?.signatoryPAN,
            // isVerified: true,
          },
          {
            idType: "AADHAR",
            idNumber: val?.aadharNumber,
            // isVerified: true,
          },
          {
            idType: "TAN",
            idNumber: val?.tanNumber,
            // isVerified: true,
          },
        ],
      },
    };
    let response = await API.Api(
      GET_CP_COMPANY_KYC + `${companyId?.newCompanyId}`
    ).put(payload);

    if (response?.status) {
      setLoading(false);
      message.success(response?.response?.data);
      localStorage.setItem("kycCompleted", JSON.stringify(false));
      handleStepsChange();
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error"
      );
    }
  };

  const validateWrapper = (event) => {
    if (checkNumbervalue(event) || checkSpace(event)) {
      event.preventDefault();
    }
  };

  const [otpStatus, setOtpStatus] = useState({
    status: null,
    message: null,
  });

  async function verifyOtp() {
    setLoading(true);

    let payload = {
      type: isGstRegister ? "GST" : "AADHAR",
      businessType: form.getFieldValue("businessType")?.toLowerCase(),
      otp: form.getFieldValue("otp"),
      number:
        form.getFieldValue("gstNumber") || form.getFieldValue("aadharNumber"),
    };
    let response = await API.Api(
      PROPS_VERIFY_KYC_OTP + `/${companyId?.customerId}`
    ).putWithHeader(payload);

    if (response?.status) {
      setLoading(false);

      if (response?.response?.data?.kycStatus == "pending") {
        console.log(response?.response?.data, "response");
        message.error(
          response?.response?.data?.message || "OTP verification failed"
        );
        setOtpStatus({
          status: "error",
          message: "OTP verification failed",
        });
      }
      if (response?.response?.data?.kycStatus == "completed") {
        message.success("OTP verified successfully");
        setEnableSave(false);
        setOtpVerified(true);
        setOtpStatus({
          status: "success",
          message: null,
        });
        localStorage.setItem(
          "selectedCompany",
          JSON.stringify({
            ...companyId,
            isKycCompleted: true,
          })
        );
      }
      if (response?.response?.data?.kycStatus == null) {
        message.error(response?.response?.data?.message);
        setOtpStatus({
          status: "error",
          message: response?.response?.data?.message,
        });
      }
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  }

  async function sentGSTOtp() {
    setLoading(true);

    let kycNumber = null;

    if (isGstRegister) {
      kycNumber = form.getFieldValue("gstNumber");
    } else {
      kycNumber = form.getFieldValue("aadharNumber");
    }

    let payload = {
      type: isGstRegister ? "GST" : "AADHAR",
      number: kycNumber,
      businessType: form.getFieldValue("businessType")?.toLowerCase(),
    };
    let response = await API.Api(
      INITIATE_KYC_OTP + `/${companyId?.customerId}`
    ).putWithHeader(payload);

    if (response?.status) {
      setLoading(false);
      if (
        response?.response?.data?.kycStatus == "pending" ||
        response?.response?.data?.kycStatus == "completed"
      ) {
        setOptVisible(true);
        message.success(
          response?.response?.data?.message || "OTP sent successfully!"
        );
        setEnableSave(true);
        setCountdown(60);
        const timer = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(timer);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }
      // if (response?.response?.data?.kycStatus == "completed") {
      //   message.success(
      //     response?.response?.data?.message || "This CP KYC is already verified"
      //   );
      // }
      if (response?.response?.data?.kycStatus == null) {
        setOptVisible(true);
        setShowVerify(true);
        message.error(response?.response?.data?.message);
      }
    } else {
      setLoading(false);
      setCountdown(120);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  }

  function handleBusinessType(params) {
    if (params == "Proprietorship" || params == "Individual") {
      setPanBusinees(false);
    } else {
      setPanBusinees(true);
    }
  }

  const [selectedCompany, setSelectedCompany] = useState(null);
  function handleCompany(params, option) {
    setSelectedCompany({ id: params, name: option?.label });
  }

  const handleSaveCompany = async () => {
    setLoading(true);

    try {
      let payload = {
        sharedKycCustomerId: selectedCompany?.id,
      };
      let response = await API.Api(
        `${GET_CP_COMPANY_KYC_SHARED}shared-kyc/${companyId?.customerId}`
      ).put(payload);

      if (response?.status) {
        setLoading(false);
        message.success(response?.response?.data?.message);
        if (response?.response?.data?.kycStatus == "completed") {
          setOtpVerified(true);
          setShareKYC(false);
          localStorage.setItem(
            "selectedCompany",
            JSON.stringify({
              ...companyId,
              isKycCompleted: true,
              sharedKYCCompanyName: selectedCompany?.name,
            })
          );
        }
      } else {
        setLoading(false);
        message.error(response?.response?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      console.log(error, "error");
    }
  };

  function handleShareKYC(params) {
    if (params.target.value) {
      setShareKYC(true);
    } else {
      setShareKYC(false);
    }
  }

  //for testing
  // function clearSelectedCompany() {
  //   localStorage.setItem(
  //     "selectedCompany",
  //     JSON.stringify({
  //       ...companyId,
  //       isKycCompleted: false,
  //       sharedKYCCompanyName: null,
  //     })
  //   );
  // }

  // useEffect(() => {
  //   clearSelectedCompany();
  // }, []);

  return (
    <Spin spinning={loading}>
      <div className="cp-detail-wrapper">
        <div className="d-flex " style={{ justifyContent: "space-between" }}>
          <Heading
            title={showSave ? "KYC Details" : "KYC Verified"}
            extra={!showSave && <Scan_check />}
          />
          {companyId?.isKycCompleted || otpVerified ? (
            <p
              style={{
                color: "green",
                fontSize: "14px",
                fontWeight: "bold",
                // border: "1px solid rgb(0, 128, 0)",
                padding: "8px 34px",
                // background: "green",
                borderRadius: "10px",
              }}
            >
              <span style={{ fontSize: "10px", marginRight: "10px" }}>
                <CheckCircleOutlined style={{ fontSize: "14px" }} />
              </span>
              VERIFIED{" "}
            </p>
          ) : (
            <p
              style={{
                color: "rgb(251, 110, 33)",
                // color: "yellow",

                fontSize: "14px",
                fontWeight: "bold",
                // border: "1px solid rgb(201, 143, 16)",
                padding: "8px 34px",
                // background: "green",
                borderRadius: "10px",
              }}
            >
              <span style={{ fontSize: "10px", marginRight: "10px" }}>
                <CloseCircleOutlined style={{ fontSize: "14px" }} />
              </span>
              NOT VERIFIED{" "}
            </p>
          )}
        </div>

        <Form
          form={form}
          layout={"vertical"}
          onFinish={onFinish}
          className="global-form"
          // disabled={!viewOnly}
          initialValues={{ isGstRegistered: true, shareKYC: false }}
        >
          <div className="global-form-row">
            {/* <Row style={{ marginBottom: "20px" }}> */}
            <Row
              gutter={24}
              style={{
                display:
                  companyId?.isKycCompleted || otpVerified ? "none" : "flex",
              }}
            >
              <Col span={12}>
                <Form.Item
                  label={
                    <span style={{ marginLeft: 5 }}>
                      Do you want to share KYC with other companies?
                      <Tooltip
                        placement="right"
                        title=" If you have multiple companies, you can share KYC"
                      >
                        <InfoCircleOutlined style={{ marginLeft: "10px" }} />
                      </Tooltip>
                    </span>
                  }
                  name="shareKYC"
                >
                  <span style={{ margin: "0 5px" }}></span>
                  <Radio.Group
                    onChange={handleShareKYC}
                    value={shareKYC}
                    // disabled={}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  label="Shared KYC company"
                  name="company"
                  rules={[
                    {
                      required: false,
                      message: "Please select company",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select company"
                    onSelect={handleCompany}
                    options={companies}
                    disabled={!shareKYC}
                  />
                </Form.Item>
              </Col>
              {shareKYC && (
                <Col span={3} style={{ marginTop: "30px" }}>
                  <Button
                    className="cancel-btn"
                    onClick={handleSaveCompany}
                    disabled={!selectedCompany}
                  >
                    CONFIRM
                  </Button>
                </Col>
              )}
            </Row>
            <Row>
              {otpVerified || companyId?.isKycCompleted ? (
                <Col span={12}>
                  <Form.Item label="Shared KYC company">
                    <Select
                      placeholder="Shared KYC company"
                      value={
                        companyId?.sharedKYCCompanyName || selectedCompany?.name
                      }
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
              ) : null}
            </Row>

            <Row gutter={24} style={{ display: shareKYC ? "none" : "flex" }}>
              <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                <Form.Item
                  label="Type of business"
                  name="businessType"
                  rules={[
                    {
                      required: true,
                      message: "Please select type of business",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select business type"
                    onChange={handleBusinessType}
                    options={typeOfBusinessOptions}
                    disabled={!showSave}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Is GST registered" name="isGstRegistered">
                  <Radio.Group
                    onChange={radioChange}
                    value={isGstRegister}
                    disabled={!showSave}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24} style={{ display: shareKYC ? "none" : "flex" }}>
              {isGstRegister ? (
                <Col span={showSave ? 9 : 12}>
                  <Form.Item
                    label="GSTIN"
                    name="gstNumber"
                    rules={[
                      {
                        message: "Please enter GSTIN",
                        required: true,
                      },
                      {
                        pattern:
                          /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/g,
                        message: "Invalid GSTIN",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter GSTIN"
                      maxLength={15}
                      onChange={(e) => {
                        setOptVisible(false);
                        setShowVerifyOtp(false);
                        form.setFieldsValue({
                          otp: null,
                        });
                        if (e.target.value.length > 13) {
                          setShowVerify(true);
                        } else {
                          setShowVerify(false);
                        }
                      }}
                      // suffix={checkStatus ? <Reason /> : null}
                      onKeyPress={(e) => {
                        if (/[^A-Za-z0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      disabled={!showSave}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col span={showSave ? 9 : 12}>
                  <Form.Item
                    label="Aadhar number"
                    name="aadharNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter aadhar number",
                      },
                    ]}
                    onKeyPress={validateWrapper}
                  >
                    <Input
                      placeholder="Enter aadhar number"
                      maxLength={12}
                      // disabled
                      onChange={(e) => {
                        setOptVisible(false);
                        setShowVerifyOtp(false);
                        if (e.target.value.length > 11) {
                          setShowVerify(true);
                        } else {
                          setShowVerify(false);
                        }
                      }}
                      disabled={!showSave}
                    />
                  </Form.Item>
                </Col>
              )}
              {showSave && (
                <>
                  <Col span={3}>
                    <Form.Item
                      label={<span style={{ visibility: "hidden" }}>.</span>}
                    >
                      <Button
                        className="cancel-btn"
                        onClick={() => {
                          if (countdown > 0) {
                            return;
                          }
                          sentGSTOtp();
                        }}
                        disabled={!showVerify}
                      >
                        {countdown > 0
                          ? `Resend OTP:${Math.floor(countdown / 60)}:${(
                              countdown % 60
                            )
                              .toString()
                              .padStart(2, "0")}`
                          : "Send OTP"}
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col span={showSave ? 9 : 12}>
                    <Form.Item
                      label="OTP"
                      name="otp"
                      validateStatus={otpStatus?.status}
                      help={otpStatus?.message}
                      rules={[
                        {
                          required: otpvisible,
                          message: "Please enter otp",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter OTP"
                        disabled={!otpvisible}
                        onChange={(e) => {
                          if (e.target.value.length > 3) {
                            setShowVerifyOtp(true);
                          } else {
                            setShowVerifyOtp(false);
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      label={<span style={{ visibility: "hidden" }}>.</span>}
                    >
                      <Button
                        className="cancel-btn"
                        onClick={() => {
                          // setVisible(true);
                          verifyOtp();
                        }}
                        disabled={!showVerifyOtp}
                      >
                        Verify OTP
                      </Button>
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>

            <Row gutter={24}>
              <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                <Form.Item
                  label="TAN Number"
                  name="tanNumber"
                  rules={[
                    {
                      required: false,
                      message: "Please Enter TAN Number",
                    },
                    {
                      pattern: /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/,
                      message: "Invalid TAN format",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter TAN Number"
                    disabled={!showSave}
                    maxLength={15}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                <Form.Item
                  label="Signatory PAN number GST"
                  name="signatoryPAN"
                  rules={[
                    {
                      required: false,
                      message: "Please enter signatory PAN number",
                    },
                    {
                      pattern: /^[A-Z]{5}\d{4}[A-Z]{1}$/,
                      message: "Invalid PAN number format",
                    },
                  ]}
                >
                  <Input
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                    placeholder="Enter signatory PAN number"
                    maxLength={12}
                    disabled={!showSave}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <hr
            className="divider"
            style={{ marginTop: "20px", marginBottom: "30px" }}
          />
          <Row
            gutter={12}
            className="mt-2"
            justify={"end"}
            style={{ flex: "auto" }}
          >
            <Col>
              <Form.Item>
                {showSave ? (
                  <Button
                    className="save-btn"
                    htmlType="submit"
                    disabled={enableSave}
                  >
                    SAVE & CONTINUE
                  </Button>
                ) : (
                  <Button
                    className="save-btn"
                    onClick={() => handleStepsChange()}
                  >
                    NEXT
                  </Button>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Spin>
  );
};

export default KycDetails;
